






































































































import LoginButton from './LoginButton.vue';
import Vue from 'vue';

export default Vue.extend({
    components: { LoginButton },
    props: {
        uid: { type: String, required: false },
        displayName: { type: String, required: false },
        showAlphaBanner: { type: Boolean, default: () => false },
    },
    computed: {
        environment: () => process.env.NODE_ENV !== 'production' ? `[${process.env.NODE_ENV}]` : '',
    },
    mounted() {
        if (this.$router.currentRoute.meta.requiresAuth && !this.uid)
            this.$router.push('/');
    },
    beforeUpdate() {
        if (this.$router.currentRoute.meta.requiresAuth && !this.uid)
            this.$router.push('/');
    },
});
